module.exports = __webpack_public_path__ + "img/roboot.9254d18d.gif";